import { ChevronDown, ChevronRight, ChevronUp } from "lucide-react";

import { GradientRim, PILL_FILL, PILL_RIM } from "@/components/ui/glass";
import { cn } from "@/lib/utils";

/**
 * The campaign switcher's "one tap away" signal, shared by the desktop pill and the mobile dock:
 * a glass pill (radial primary fill + gradient rim, the active-tab language) carrying the "+N
 * others" count and a chevron pointing where the list unfolds — down from the desktop pill, up
 * from the dock, right from the side dock — that flips while it is open. No aria-label: the visible "+N" is the accessible
 * text, the same exposure as the launcher badge (and no new translation key). Decorative inside
 * the trigger button, which owns the click and the `aria-expanded`.
 */
export const SwitcherCountPill = ({
  count,
  open,
  unfolds,
  className,
}: {
  count: number;
  open: boolean;
  unfolds: "up" | "down" | "right";
  className?: string;
}) => {
  const Chevron =
    unfolds === "up"
      ? ChevronUp
      : unfolds === "right"
        ? ChevronRight
        : ChevronDown;
  return (
    <span
      className={cn(
        "relative flex h-8 shrink-0 items-center gap-0.5 overflow-hidden rounded-full pr-1.5 pl-3 font-heading text-[13px] font-bold text-primary-foreground lg:h-9 lg:text-sm",
        className
      )}
      style={{ background: PILL_FILL }}
    >
      <GradientRim background={PILL_RIM} />
      <span className="relative">+{count}</span>
      <Chevron
        className={cn(
          "relative size-5 transition-transform duration-150",
          open && "rotate-180"
        )}
        strokeWidth={2.5}
        aria-hidden="true"
      />
    </span>
  );
};
